/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  IconButton,
  Input,
  InputAdornment,
  makeStyles,
  MenuItem,
  TextField,
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import React, { useCallback, useEffect, useMemo, useState } from 'react'

import BaseFilter from '../../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import Icon from '@mdi/react'
import { mdiClockPlusOutline, mdiMagnifyExpand } from '@mdi/js'
import colors from '../../../../assets/colors'
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { useQueryParams } from '../../../../util/utils'
import { useSelector } from 'react-redux'
import { usePermissions } from '../../../../hooks/usePermission'
import SelectField from '../../../components/SelectField'
import SearchIcon from '@material-ui/icons/Search'
import formComponentStyles from '../../../../assets/formComponentsStyles'

const useStyles = makeStyles({
  appointmentBtn: {
    fontSize: '14px',
    padding: '4px 8px',
    margin: 0,
    width: 'auto',
    borderRadius: '8px',

    backgroundColor: colors.sucess,
    color: 'white',
    transition: 'all .4s ease-in-out',

    '&:hover': {
      backgroundColor: colors.sucess,
      opacity: 0.6,
    },
  },
})

export default function Filter(props) {
  const classes = useStyles()
  const styles = filterStylesComponents()

  const laundries = useSelector(state => state.appointments.laundries)
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location.search)

  const [open, setOpen] = useState(false)
  const [form, setForm] = useState({
    laundry: {},
  })

  const handleToggle = () => {
    setOpen(!open)
  }

  const laundryFiltered = useMemo(() => {
    if (!laundries?.length) return ''
    if (!filters?.laundry_id) return ''
    return laundries?.find(r => r?.id == filters?.laundry_id)
  }, [laundries, filters])

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)

    data.append('laundry_id', form.laundry?.id || '')

    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  useEffect(() => {
    if (!laundryFiltered) return
    setForm({ ...form, laundry: laundryFiltered })
  }, [laundryFiltered])

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={2} alignItems="center">
                <Grid item sm={4} xs={12}>
                  <SelectField
                    options={laundries}
                    setForm={(name, value) => {
                      setForm({ ...form, laundry: value })
                    }}
                    data={form?.laundry || ''}
                    variant="standard"
                    name="status"
                    label="Filtre por lavanderia"
                  />
                </Grid>

                <Grid item sm={3} xs={12}>
                  <TextField
                    select
                    name="status"
                    label="Status"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.status || ''}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    <MenuItem value={0}>Fechado</MenuItem>
                    <MenuItem value={1}>Aberto</MenuItem>
                  </TextField>
                </Grid>

                <Grid item>
                  <Button
                    type="submit"
                    color={colors.primary}
                    variant="contained"
                    className={styles.btnAdd}
                  >
                    <SearchIcon />
                    {` Pesquisar`}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>

          {canCreate('modulo-parceiros-agendamentos', permissionUser) && (
            <Grid item>
              <IconButton
                className={classes.appointmentBtn}
                component={Link}
                to={`appointments/new${location.search}`}
              >
                <Icon
                  path={mdiClockPlusOutline}
                  size={1}
                  style={{ marginRight: '4px' }}
                />
                <span>Novo Agendamento Avulso</span>
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    </BaseFilter>
  )
}
